<div class="modal-header">
    <h5 class="modal-title mb-0 sd-text-primary">Product List</h5>
    <button type="button" class="btn-close custom-close-btn" aria-label="Close" (click)="cancelPopup()"></button>
</div>

<div class="modal-body text-center py-4">
    <div class="table-responsive">
        <h5 class="mb-0 sd-text-primary text-start">Invoice Details</h5>
        <table class="table table-bordered table-hover align-middle text-nowrap">
            <thead class="custom-header">
                <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Bag No</th>
                    <th>Material Type</th>
                    <th>Category</th>
                    <th>Style</th>
                    <th>Clarity</th>
                    <th>KT</th>
                    <th>IGI No</th>
                    <th>HUID</th>
                    <th>Dia Wt</th>
                    <th>Net Wt</th>
                    <th>Dia Qty</th>
                    <th>Dp Price</th>
                    <th>Selling Price</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of paginatedInvoiceData; let i = index">
                    <td>{{ (invoiceCurrentPage - 1) * itemsPerPage + i + 1 }}</td>
                    <td><img [src]="data.image" alt="Invoice Image" style="max-width: 50px; max-height: 50px;" /></td>
                    <td>{{ data.bagNo }}</td>
                    <td>{{ data.materialType }}</td>
                    <td>{{ data.category }}</td>
                    <td>{{ data.style }}</td>
                    <td>{{ data.clarity }}</td>
                    <td>{{ data.karat }}</td>
                    <td>{{ data.igiNo }}</td>
                    <td>{{ data.huid }}</td>
                    <td>{{ data.diaWt }}</td>
                    <td>{{ data.netWt }}</td>
                    <td>{{ data.diaQty }}</td>
                    <td>{{ data.dpPrice }}</td>
                    <td>{{ data.selingPrice }}</td>
                </tr>
                @if((invoiceDetails?.length ?? 0) === 0){
                <tr>
                    <td colspan="15" class="text-center">No Data Available</td>
                </tr>
                }
            </tbody>
        </table>

        @if(invoiceTotalPages > 1){
        <nav aria-label="Page navigation" class="mt-3">
            <ul class="pagination justify-content">
                <li class="page-item" [class.disabled]="invoiceCurrentPage === 1">
                    <button class="page-link" (click)="goToInvoicePage(invoiceCurrentPage - 1)"
                        [disabled]="invoiceCurrentPage === 1">
                        Previous
                    </button>
                </li>
                <li class="page-item" *ngFor="let page of invoicePages" [class.active]="page === invoiceCurrentPage">
                    <button class="page-link" (click)="goToInvoicePage(page)">{{ page }}</button>
                </li>
                <li class="page-item" [class.disabled]="invoiceCurrentPage === invoiceTotalPages">
                    <button class="page-link" (click)="goToInvoicePage(invoiceCurrentPage + 1)"
                        [disabled]="invoiceCurrentPage === invoiceTotalPages">
                        Next
                    </button>
                </li>
            </ul>
        </nav>
        }
    </div>
</div>